import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl, Tabs, Tab, ButtonGroup } from 'react-bootstrap';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import CompanyPage from './CompanyPage';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import { Link } from 'react-router-dom';
import MaskedInput from '../components/MaskedInput';
import ErrorComponent from '../components/ErrorComponent';

export default class CompanyDetailPage extends PageComponent {

  roles = ["CUSTOMER_USER", "CUSTOMER_ADMIN"];

  static PageInfo = {
    parent: CompanyPage,
    hidden: true,
    path: "/Client/Detail/:id",
    name: "menu.client",
    permission: { "COMPANY_ACCESSING": true },
    access: { 1: true, 2: true },
    icon: "building"
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.dataa = null;
    this.state.dataHistory = [];
    this.state.modalLoading = false;
    this.state.selectedUser = null;
    this.state.modalError = null;
    this.state.loading = true;
    this.state.states = null;
    this.state.isModalVisible = null;
    this.state.phone = "";
    this.state.selectedState = null;
    this.state.form = {};
  }

  componentDidMount() {

    Connection.Secure(Connection.service + 'Company/Detail/' + this.data.id)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            if (data.company != null && data.company.companyType.keyConstant == 3)
              this.roles = ["PROVIDER_ADMIN"];
            else if (data.detail != null && data.detail.customerType.bunch == "ZFR")
              this.roles = ["FRANCHISEE_ADMIN"];
            this.setState({ loading: false, data: data });
          });
        else this.setState({ error: response, loading: false });



        Connection.Secure(Connection.service + 'User/History/' + this.data.id)
          .then((response) => {
            if (response.status == 200)
              response.json().then((dataa) => {
                this.state.dataHistory = dataa;
                console.log('CompanyDetailPage -> ' + JSON.stringify(this.state.dataHistory))
                this.setState({ loading: false, dataa: this.state.dataHistory });
              });
            else this.setState({ error: response, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error, loading: false });
          });



      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });




  }





  savePhone() {
    Connection.Secure(Connection.service + 'Company/AddInfo/' + this.data.id,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ value: this.state.phone, valueType: { keyConstant: 9 } })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.state.data.companyValue.push(data);
            this.setState({ modalLoading: false, phone: "", isModalVisible: null, data: this.state.data });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }

  saveAddress() {
    this.saveUser()
    this.state.form.state = { keyConstant: parseInt(this.state.selectedState) };
    this.state.form.addressType = { keyConstant: 3 };
    Connection.Secure(Connection.service + 'Company/AddAddress/' + this.data.id,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            this.state.data.address.push(data);
            this.setState({ modalLoading: false, phone: "", isModalVisible: null, data: this.state.data });
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }



  saveUser() {
    this.state.form.personPermissionGroupMainPerson = [{ logicalApGroups: { name: this.state.selectedRole } }];
    this.state.form.personValue = [
      { value: this.state.form.userName, valueType: { keyConstant: 1 } },
      { value: this.state.form.email, valueType: { keyConstant: 3 } }
    ];
    Connection.Secure(Connection.service + 'Company/AddUser/' + this.data.id,
      {
        "method": "POST",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.state.form)
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            var l = (window.location.pathname.replace(/\/$/ig, "") + "/User/" + data).replace(/\/\//ig, "/");
            this.setState({ isModalVisible: false, modalLoading: false },
              () => this.props.history.push(l));
          });
        else if (response.status == 409) this.setState({ isModalVisible: "alreadyuser", modalLoading: false });
        else if (response.status == 208) this.setState({ isModalVisible: "sameuser", modalLoading: false });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
    this.setState({ modalLoading: true });
  }

  deleteItem(item) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + (
      "Company/RemoveUser/" + this.data.id + "/User/" + item.mainPerson.keyRegister + "/PermissionGroup/" + encodeURI(item.logicalApGroups.name)
    ),
      {
        "method": "DELETE",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          try {
            this.state.data.company.personPermissionGroup.splice(this.state.data.company.personPermissionGroup.indexOf(item), 1);
          } catch (e) { }
          this.setState({ modalLoading: false, isModalVisible: false, data: this.state.data });
        } else
          this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  openModal(target) {
    var t = {
      isModalVisible: target,
      modalLoading: false,
      modalInitializing: false,
      modalError: null
    };
    if (target === "ADDRESS") {
      Connection.Secure(Connection.service + 'State/List/')
        .then((response) => {
          if (response.ok && response.status == 200)
            response.json().then((data) => {
              setTimeout(() => this.setState({ states: data }, this.setState({ modalInitializing: false })));
            });
          this.setState({ modalInitializing: false });
        })
        .catch((error) => {
          this.setState({ modalInitializing: false });
        });
      t.modalInitializing = true;
      t.selectedState = null;
    }
    t.form = {};
    this.setState(t);
  }

  setForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  checkForm() {
    if (typeof this.state.form !== "object" || this.state.form == null)
      return false;
    for (var i in this.state.form)
      if (this.state.form[i] == null) {
        return false;
      }
    return true;
  }

  renderInfo(target, filter) {
    var d = [];
    if (this.state.data.company != null && Array.isArray(this.state.data.company.companyValue))
      d = this.state.data.company.companyValue;

    d = d.filter(filter);
    if (d.length == 0) return <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>;
    return d.map((item) => target(item));
  }

  renderPhone(item) {
    return <div className="generics_listing_item" >
      <FontAwesomeIcon icon='phone' className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{item.value}</div>
        <div className="generics_listing_item_description" >{Labels.GetLabel("information." + item.valueType.label)}</div>
      </div>
      {/* <div className="generics_listing_item_action" onClick={(e) => this.deleteItem(e, op, item)}><FontAwesomeIcon icon="times" /></div> */}
    </div>
  }

  renderHistory(item) {
    return <div className="row generics_listing_item">
      <div className="col-sm-1 generics_listing_item_description" >{item.nameUser}</div>
      <div className="col-sm-2 generics_listing_item_description" >{item.emailUser}</div>
      <div className="col-sm-2 generics_listing_item_description" >{item.newCpf}</div>
      <div className="col-sm-2 generics_listing_item_description" >{item.oldCpf}</div>
      <div className="col-sm-2 generics_listing_item_description" >{item.modifiedName}</div>
      <div className="col-sm-2 generics_listing_item_description" >{Parsers.parseDate(item.datetimeAlteration)}</div>
      <div className="col-sm-1 generics_listing_item_description" >{item.userStatus}</div>
    </div>
  }

  renderAddress(item) {
    return <div className="generics_listing_item" >
      <FontAwesomeIcon icon='map-marker-alt' className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{Parsers.parseAddress(item)}</div>
        <div className="generics_listing_item_description" >{Parsers.parseAddressCity(item)}</div>
      </div>
      {/* <div className="generics_listing_item_action" onClick={(e) => this.deleteItem(e, op, item)}><FontAwesomeIcon icon="times" /></div> */}
    </div>
  }

  renderUser(item) {
    var l = window.location.pathname.replace(/\/$/ig, "") + "/User/" + item.mainPerson.keyRegister;
    return <Link to={l} className="generics_listing_item" >
      <FontAwesomeIcon icon="user" className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{Parsers.parseUpperCase(GenericHelper.parseInformation(item.mainPerson.personValue, 1, "valueType"))}{item.mainPerson.brand ? <span>{item.mainPerson.brand.label}</span> : null}</div>
        <div className="generics_listing_item_description" >{GenericHelper.parseInformation(item.mainPerson.personValue, 9, "valueType", null, "Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 8, "valueType", null, " Tel.:")}{GenericHelper.parseInformation(item.mainPerson.personValue, 7, "valueType", null, " ")}</div>
        <div className="generics_listing_item_description" >{Parsers.parseLowerCase(GenericHelper.parseInformation(item.personValue, 3, "valueType", null, " Email:"))}
          <span>{Labels.GetLabel("permission." + item.logicalApGroups.name)}</span>
        </div>
      </div>
      {!Parsers.parsePermission2(["CONFIGURATION_USERS_EDIT"]) ? null : <div className="generics_listing_item_action" onClick={(e) => { this.setState({ selectedUser: item, isModalVisible: "deleteuser" }); return GenericHelper.cancelBubble(e); }}><FontAwesomeIcon icon="times" /></div>}
    </Link>
  }

  renderProgram(item) {
    var l = "/Program/Detail/" + item.id + "/Goal/" + this.data.id;
    return <Link to={l} className="generics_listing_item" >
      <FontAwesomeIcon icon="trophy" className="generics_listing_item_icon" />
      <div className="generics_listing_content" >
        <div className="generics_listing_item_title" >{Parsers.parseUpperCase(item.label)}</div>
        <div>{item.brand.label}</div>
      </div>
    </Link>
  }

  renderProps(target) {
    var p = [];
    for (var i in target)
      if (target[i] != null) p.push([i, target[i]]);
    p.sort(this.compare);
    return p.map(item =>
      <div className="generics_infobox">
        <div className="generics_infobox_label">{item[0]}</div>
        <div className="generics_infobox_value">{item[1]}</div>
      </div>);
  }

  compare(a, b) {
    if (a[0] < b[0]) {
      return -1;
    }
    if (a[0] > b[0]) {
      return 1;
    }
    return 0;
  }



  render() {
    return (
      <Container context={this.constructor} props={this.data}>
        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ display: "block" }}>
                <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span>{this.state.data.detail == null ? this.state.data.company.name : this.state.data.detail.name1 + (this.state.data.detail.name2 == null ? "" : this.state.data.detail.name2)
                  + (this.state.data.detail.name3 == null ? "" : this.state.data.detail.name3)
                  + (this.state.data.detail.name4 == null ? "" : this.state.data.detail.name4)}</span>
                  <div>{Labels.GetLabel("generic.docnumb")}: {this.state.data.detail == null ? Parsers.parseCPNJ(this.state.data.company.criticalValue) : this.state.data.detail.cnpjCode == null ? Parsers.parseCPNJ(this.state.data.detail.cpfCode) : Parsers.parseCPNJ(this.state.data.detail.cnpjCode)}</div>
                </div>
                <div style={{ padding: 20 }}>
                  {
                    this.state.data.detail == null ?
                      <div></div> :
                      <div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.customercode")}</div>
                          <div className="generics_infobox_value">{this.state.data.detail.customerCode}</div>
                        </div>
                        {
                          this.state.data.detail.headOfficeAcc == null ? null :
                            <div className="generics_infobox">
                              <div className="generics_infobox_label">{Labels.GetLabel("generic.payercode")}</div>
                              <div className="generics_infobox_value">{this.state.data.detail.headOfficeAcc}</div>
                            </div>}
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("program.type")}</div>
                          <div className="generics_infobox_value">{Labels.GetLabel("CLIENT_TYPE." + this.state.data.detail.customerType.bunch)}</div>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <br />
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.street")}</div>
                          <div className="generics_infobox_value">{this.state.data.detail.street}</div>
                        </div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.streetnumb")}</div>
                          <div className="generics_infobox_value">{parseInt(this.state.data.detail.addressNr)}</div>
                        </div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.streetcode")}</div>
                          <div className="generics_infobox_value">{this.state.data.detail.postalCode}</div>
                        </div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.state")}</div>
                          <div className="generics_infobox_value">{this.state.data.detail.region}</div>
                        </div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.city")}</div>
                          <div className="generics_infobox_value">{this.state.data.detail.city}</div>
                        </div>
                        <div className="generics_infobox">
                          <div className="generics_infobox_label">{Labels.GetLabel("generic.accountgroup")}</div>
                          <div className="generics_infobox_value">{this.state.data.detail.accountGroup}</div>
                        </div>
                        <div style={{ clear: "both" }}></div>
                        <br />
                      </div>}
                  {
                    this.state.data.company != null && this.state.data.company.companyType.keyConstant == 2 ?
                      <div>
                        <div className="generic_section_header">{Labels.GetLabel('menu.programs')}</div>
                        <div>
                          {
                            this.state.data.program == null ||
                              !Array.isArray(this.state.data.program) ||
                              this.state.data.program.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                              :
                              this.state.data.program.map((item) => this.renderProgram(item))
                          }
                        </div>
                        <br />
                      </div>
                      : null
                  }
                  <div className="generic_section_header">{Labels.GetLabel('clientdetail.usersheader')}
                    {
                      !Parsers.parsePermission2("CONFIGURATION_USERS_EDIT") ? null :
                        <div className="generic_section_header_action" onClick={() => this.openModal("USER")}><FontAwesomeIcon icon="plus" /></div>
                    }</div>
                  <div>
                    {
                      this.state.data.company == null ||
                        !Array.isArray(this.state.data.company.personPermissionGroup) ||
                        this.state.data.company.personPermissionGroup.length == 0 ? <div className="generic_empty">{Labels.GetLabel('adminstategroupdetail.empty')}</div>
                        :
                        this.state.data.company.personPermissionGroup.map((item) => this.renderUser(item))
                    }
                  </div></div>


                <div className="generics_actionbar">
                  {!Parsers.parsePermission2(["CONFIGURATION_USERS_EDIT"]) ? null : <DropdownButton
                    as={ButtonGroup}
                    key="up"
                    drop="up"
                    variant="primary" style={{ marginRight: 10 }}
                    title={Labels.GetLabel("userhistory.history")}
                    onSelect={(t) => this.openModal(t)}
                  >
                    <Dropdown.Item eventKey="history" >{Labels.GetLabel("userhistory.history")}</Dropdown.Item>
                  </DropdownButton>}
                  <div style={{ flex: 1 }}></div>
                  <div style={{ clear: "both" }}></div>
                </div>




              </div>
        }


        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "history" }>
          <div>
            {
              
                    <div>
                      <Modal.Header>
                        <Modal.Title>{Labels.GetLabel("userhistory.history")}</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        
                          <div className="row">
                            <div className="col-sm-1 generics_listing_item_title" >{Labels.GetLabel("userhistory.name")}</div>
                            <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.email")}</div>
                            <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.cpfnew")}</div>
                            <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.cpfold")}</div>
                            <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.modifiedname")}</div>
                            {/* <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.modifiedemail")}</div> */}
                            {/* <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.datetimeregister")}</div> */}
                            <div className="col-sm-2 generics_listing_item_title" >{Labels.GetLabel("userhistory.datetimeupdate")}</div>
                            <div className="col-sm-1 generics_listing_item_title" >{Labels.GetLabel("userhistory.status")}</div>
                            {this.state.dataHistory.map((item) => this.renderHistory(item))}
                          </div>
                        
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                          {Labels.GetLabel("userhistory.closebtn")}
                        </Button>
                      </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                    </div>
                  
            }
          </div>
        </Modal>

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "TELEPHONE"}>
          <div>
            {
              this.state.modalInitializing == false ?
                <div>
                  <Modal.Header>
                    <Modal.Title>{Labels.GetLabel("information.TEL_WORK")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <MaskedInput type="tel" icon="phone" label={Labels.GetLabel("clientsnew.streetnumb")} notnull={true} onValid={(value) => this.setState({ phone: value })}
                      onInvalid={(value) => this.setState({ phone: null })} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                      {Labels.GetLabel("adminstategroup.closebtn")}
                    </Button>
                    <Button variant="primary" disabled={this.state.phone == null} onClick={() => this.savePhone()}>
                      {Labels.GetLabel("adminstategroup.savebtn")}
                    </Button>
                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                </div>
                : <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
            }
          </div>
        </Modal>

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "deleteuser"}>
          <div>
            {
              this.state.modalInitializing == false ?
                <div>
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("generic.delete")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {Labels.GetLabel("generic.confirmdel")}
                      <br />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                      <Button variant="primary" onClick={() => this.deleteItem(this.state.selectedUser)}>
                        {Labels.GetLabel("generic.confirm")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
                  :
                </div>
                : <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
            }
          </div>
        </Modal>

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "ADDRESS"}>
          <div>
            {
              this.state.modalInitializing == false ?
                <div>
                  <Modal.Header>
                    <Modal.Title>{Labels.GetLabel("information.ADDRESS_WORK")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    {this.state.modalInitializing == true || this.state.states == null ? null :
                      <MaskedInput type="select" label={Labels.GetLabel("clientdetail.streetstate")} notnull={true} onValid={(value) => this.setState({ selectedState: value[0] })}
                        onInvalid={(value) => this.setState({ selectedState: null })} name="keyConstant,description" data={() => { return this.state.states }} placeholder={Labels.GetLabel("generic.select")} />
                    }

                    <MaskedInput type="text" label={Labels.GetLabel("clientdetail.streetcity")} notnull={true} onValid={(value) => this.setForm("locality", (value))}
                      onInvalid={(value) => this.setForm("locality", null)} />

                    <MaskedInput type="text" label={Labels.GetLabel("clientdetail.street")} notnull={true} onValid={(value) => this.setForm("placeName", (value))}
                      onInvalid={(value) => this.setForm("placeName", null)} />

                    <MaskedInput type="int" label={Labels.GetLabel("clientdetail.streetnumb")} notnull={true} onValid={(value) => this.setForm("placeNumber", parseInt(value))}
                      onInvalid={(value) => this.setForm("placeNumber", null)} />
                    <MaskedInput type="text" label={Labels.GetLabel("clientdetail.streetcomplement")} notnull={true} onValid={(value) => this.setForm("complement", (value))}
                      onInvalid={(value) => this.setForm("complement", null)} />

                    <MaskedInput type="text" label={Labels.GetLabel("clientdetail.streetneigh")} notnull={true} onValid={(value) => this.setForm("neighborhood", (value))}
                      onInvalid={(value) => this.setForm("neighborhood", null)} />

                    <MaskedInput type="cep" label={Labels.GetLabel("clientdetail.streetcode")} notnull={true} onValid={(value) => this.setForm("cep", (value))}
                      onInvalid={(value) => this.setForm("cep", null)} />

                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                      {Labels.GetLabel("adminstategroup.closebtn")}
                    </Button>
                    <Button variant="primary" disabled={this.state.selectedState == null || !this.checkForm()} onClick={() => this.saveAddress()}>
                      {Labels.GetLabel("adminstategroup.savebtn")}
                    </Button>
                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                </div>
                : <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
            }
          </div>
        </Modal>

        <Modal
          className={this.state.modalLoading == true ? "modal-loading" : ""}
          onHide={() => { }} show={this.state.isModalVisible == "USER" ||
            this.state.isModalVisible == "sameuser" ||
            this.state.isModalVisible == "alreadyuser"}>
          <div>
            {
              this.state.modalInitializing == false ?
                this.state.isModalVisible == "sameuser" ||
                  this.state.isModalVisible == "alreadyuser" ?
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("clientdetail.newUser")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {Labels.GetLabel("program." + this.state.isModalVisible)}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div> :
                  <div>
                    <Modal.Header>
                      <Modal.Title>{Labels.GetLabel("clientdetail.newUser")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <MaskedInput type="select" icon="sitemap" label={Labels.GetLabel("clientdetail.role")} notnull={true} onValid={(value) => this.setState({ selectedRole: value[0] })}
                        onInvalid={(value) => this.setState({ selectedRole: null })} data={this.roles} parser={(t) => Labels.GetLabel("permission." + t)} placeholder={Labels.GetLabel("generic.select")} />

                      <MaskedInput type="fname" icon="info-circle" label={Labels.GetLabel("clientdetail.username")} notnull={true} onValid={(value) => this.setForm("userName", (value))}
                        onInvalid={(value) => this.setForm("userName", null)} />

                      <MaskedInput type="cpf" icon="id-card" label={Labels.GetLabel("clientdetail.usercpf")} notnull={true} onValid={(value) => this.setForm("criticalValue", (value))}
                        onInvalid={(value) => this.setForm("criticalValue", null)} />

                      <MaskedInput type="email" icon="envelope" label={Labels.GetLabel("clientdetail.email")} notnull={true} onValid={(value) => this.setForm("email", (value))}
                        onInvalid={(value) => this.setForm("email", null)} />
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: false })}>
                        {Labels.GetLabel("adminstategroup.closebtn")}
                      </Button>
                      <Button variant="primary" disabled={this.state.selectedRole == null || !this.checkForm()} onClick={() => this.saveAddress()}>
                        {Labels.GetLabel("adminstategroup.savebtn")}
                      </Button>
                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                  </div>
                : <div>
                  {Labels.GetLabel("adminstategroup.saving")}
                </div>
            }
          </div>
        </Modal>
      </Container>
    );


    // "street": { "EN": "Address", "PT": "Endereço" },
    // "streetnumb": { "EN": "Number", "PT": "Número" },
    // "streetcomplement": { "EN": "Complement", "PT": "Complemento" },
    // "streetneigh": { "EN": "District", "PT": "Bairro" },
    // "streetstate": { "EN": "State", "PT": "Estado" },
    // "streetcity": { "EN": "City", "PT": "Cidade" },
    // "streetcode": { "EN": "Zipcode", "PT": "CEP" },
  }
}

